// src/components/FloatingWhatsApp.js
import React from "react";
import "./floatingWhatsApp.css";

const FloatingWhatsApp = () => {
  // Replace with your WhatsApp number (no '+' or dashes)
  const phoneNumber = "+923210111707"; // e.g., 92 = Pakistan code
  const message = "Hello! I would like to know more about Apna Card.";

  const handleClick = () => {
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <div className="whatsapp-float" onClick={handleClick}>
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
        alt="WhatsApp"
      />
    </div>
  );
};

export default FloatingWhatsApp;
